// import { io } from "socket.io-client";

// export const connectSocket = () => {
//   return io("http://localhost:5050", {
//     transports: ["websocket"],
//   });
// };

// import { io } from "socket.io-client";

// // If we're running on localhost (React dev server), use port 5050.
// // Otherwise, connect back to the same origin that served the page.
// const SOCKET_URL =
//   window.location.hostname === "localhost"
//     ? "http://localhost:5050"
//     : window.location.origin;

// export function connectSocket() {
//   return io(SOCKET_URL, {
//     path: "/socket.io",
//     transports: ["websocket"],
//   });
// }

// src/socket.js
// import { io } from "socket.io-client";

// const isLocal = window.location.hostname === "localhost";
// const backendFromEnv = process.env.REACT_APP_BACKEND_URL;

// // if env var is set, use it, otherwise if localhost use 5050, else
// // fall back to window.location.origin (should never happen in prod)
// let SOCKET_BASE_URL = backendFromEnv
//   ? backendFromEnv.replace(/\/$/, "")    // drop trailing slash
//   : isLocal
//   ? "http://localhost:5050"
//   : window.location.origin;

// // convert http→ws and https→wss automatically
// if (SOCKET_BASE_URL.startsWith("http")) {
//   SOCKET_BASE_URL = SOCKET_BASE_URL.replace(/^http/, "ws");
// }

// export function connectSocket() {
//   return io(SOCKET_BASE_URL, {
//     path: "/socket.io",
//     transports: ["websocket"],
//     secure: SOCKET_BASE_URL.startsWith("wss"),
//   });
// }

// src/socket.js
import { io } from "socket.io-client";

// For local development, default to port 8000 where the backend is running
const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

let SOCKET_URL;
if (process.env.REACT_APP_BACKEND_URL) {
  SOCKET_URL = process.env.REACT_APP_BACKEND_URL;
} else if (isLocalhost) {
  // Default to backend port 8000 for local development
  SOCKET_URL = "http://localhost:8000";
} else {
  // For production, use the same origin (HTTPS)
  // This assumes nginx is proxying both frontend and backend
  SOCKET_URL = window.location.origin;
}

console.log("🔌 Connecting to Socket.IO server at:", SOCKET_URL);
console.log("🌍 Current hostname:", window.location.hostname);
console.log("🔧 Is localhost:", isLocalhost);

export function connectSocket() {
  return io(SOCKET_URL, {
    path: "/socket.io",
    transports: ["websocket", "polling"], // Allow both transports for better compatibility
    timeout: 120000, // 2 minutes timeout
  });
}

